module.exports = __webpack_public_path__ + "img/card1.752c042c.png";